/**
 * Represents the map of different types of status for a VulnerabilityReport.
 *
 * @example //getting the status from a report
 * const status = metaVulnReportStatus[report?.status]?.displayName;
 */
export const metaVulnReportStatus = {
    Unknown: { value: 0, displayName: 'Unknown', order: 0 },
    Draft: { value: 5, displayName: 'Draft', order: 5 },
    Submitted: { value: 6, displayName: 'Submitted', order: 6 },
    New: { value: 100000000, displayName: 'New', order: 10 },
    Complete: { value: 100000001, displayName: 'Complete', order: 11 },
    ReviewRepro: { value: 100000002, displayName: 'Review / Repro', order: 12 },
    Develop: { value: 100000003, displayName: 'Develop', order: 13 },
    PreRelease: { value: 100000004, displayName: 'Pre-Release', order: 14 },
    CompleteNA: { value: 100000011, displayName: 'Complete - NA', order: 15 },
    NewDuplicate: { value: 100000005, displayName: 'New - Duplicate', order: 16 },
    ReviewReproDuplicate: {
        value: 100000007,
        displayName: 'Review / Repro - Duplicate',
        order: 17,
    },
    DevelopDuplicate: {
        value: 100000008,
        displayName: 'Develop - Duplicate',
        order: 18,
    },
    PreReleaseDuplicate: {
        value: 100000009,
        displayName: 'Pre-Release - Duplicate',
        order: 19,
    },
    CompleteDuplicate: {
        value: 100000010,
        displayName: 'Complete - Duplicate',
        order: 20,
    },
    CompleteResolved: {
        value: 100000012,
        displayName: 'Complete - Resolved',
        order: 21,
    },
    Closed: { value: 21, displayName: 'Closed', order: 22 },
};
